export interface GeocodingFeature {
	id: string;
	place_name: string;
	center: [number, number];
}

export const LOCATION_DISTANCE_PRESETS = [10, 25, 50, 100] as const;
export type LocationDistancePreset = (typeof LOCATION_DISTANCE_PRESETS)[number];
export const DEFAULT_LOCATION_RADIUS_KM: LocationDistancePreset = 50;

export const useMapboxGeocoding = () => {
	const token = import.meta.env.VITE_MAPBOX_API ?? "";

	const searchPlaces = async (query: string): Promise<GeocodingFeature[]> => {
		if (!query.trim() || !token) {
			return [];
		}

		const url = new URL(
			`https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(query)}.json`,
		);
		url.searchParams.set("access_token", token);
		url.searchParams.set("types", "place,locality,region,district,country");
		url.searchParams.set("limit", "5");

		const response = await fetch(url.toString());

		if (!response.ok) {
			return [];
		}

		const data = await response.json();
		return data.features ?? [];
	};

	return { searchPlaces };
};

export const getZoomForRadiusKm = (radiusKm: number): number => {
	if (radiusKm <= 10) return 11;
	if (radiusKm <= 25) return 10;
	if (radiusKm <= 50) return 9;
	return 8;
};
